// Speed test logic
export function CanvasSpeedtestMobile(canvasObject,userOptions) {
  // Default paramteres
  this.defaults =
    {
      //increment30mb: 0.1,
      increment300mb: 0.5,
      //increment1gb: 1,
      incrementYourSpeed: 0.1,
      yourSpeed: '10 Mbps'
    };

  // Extend defaults with user options (if exists)
  this.options = $.extend({},this.defaults);
  if( userOptions )
  {
    $.extend( this.options, userOptions );
  }

  // ---------------------------------------------------------
  // Product parameters
  // this.params30mb =
  //   {
  //     x: 400,
  //     y: 400,
  //     radius: 230,
  //     endPercent: 75,
  //     curPercent: 0
  //   }

  this.params300mb =
    {
      x: 400,
      y: 400,
      radius: 300,
      endPercent: 75,
      curPercent: 0
    }

  this.params1gb =
    {
      x: 400,
      y: 400,
      radius: 370,
      endPercent: 75,
      curPercent: 0
    }

  this.paramsYourSpeed =
    {
      x: 400,
      y: 400,
      radius: 160,
      endPercent: 75,
      curPercent: 0
    }

  // ---------------------------------------------------------
  // Canvas
  this.canvas = this.canvas = $('#'+canvasObject)[0];
  this.ctx = this.canvas.getContext('2d');


  // ---------------------------------------------------------
  // Interval var
  this.intervalAnim;

  // ---------------------------------------------------------
  // Start the show
  this.Init();
}

CanvasSpeedtestMobile.prototype.SetOptions = function(userOptions)
{
  // Extend defaults with user options (if exists)
  this.options = $.extend({},this.defaults);
  if( userOptions )
  {
    $.extend( this.options, userOptions );
  }

  //this.params30mb.curPercent = 0;
  this.params300mb.curPercent = 0;
  //this.params1gb.curPercent = 0;
  this.paramsYourSpeed.curPercent = 0;

  clearInterval(self.intervalAnim);
}

CanvasSpeedtestMobile.prototype.Init = function()
{
  var self = this;

  self.DrawStatic();

  //self.Draw(self.params30mb, self.options.increment30mb);
  self.Draw(self.params300mb, self.options.increment300mb);
  //self.Draw(self.params1gb, self.options.increment1gb);
  self.Draw(self.paramsYourSpeed, self.options.incrementYourSpeed);
}

CanvasSpeedtestMobile.prototype.Start = function()
{
  var self = this;
  clearInterval(self.intervalAnim);

  self.intervalAnim = setInterval(function ()
  {
    self.BeforeDraw();
    self.DrawStatic();

    //self.Draw(self.params30mb, self.options.increment30mb);
    self.Draw(self.params300mb, self.options.increment300mb);
    //self.Draw(self.params1gb, self.options.increment1gb);
    self.Draw(self.paramsYourSpeed, self.options.incrementYourSpeed);

    if( 
      //self.params30mb.curPercent >= self.params30mb.endPercent &&
      self.params300mb.curPercent >= self.params300mb.endPercent &&
      //self.params1gb.curPercent >= self.params1gb.endPercent &&
      self.paramsYourSpeed.curPercent >= self.paramsYourSpeed.endPercent
    )
    {
      clearInterval(self.intervalAnim);
    }

  },10);
}

CanvasSpeedtestMobile.prototype.BeforeDraw = function()
{
  var self = this;

  // Celar canvas
  self.ctx.clearRect(0, 0, self.canvas.width, self.canvas.height);
}

CanvasSpeedtestMobile.prototype.DrawStatic = function()
{
  var self = this;

  // Text - 30MB
  // self.ctx.font = 'bold 30px "Source Sans Pro"';
  // self.ctx.fillStyle = '#FFF';
  // self.ctx.textAlign="right";
  // self.ctx.fillText("30 Mbps",370,180);

  // White circle path - 30MB
  // self.ctx.lineWidth = 2;
  // self.ctx.strokeStyle = '#FFF';
  // self.ctx.beginPath();
  // self.ctx.arc(self.params30mb.x, self.params30mb.y, self.params30mb.radius, -(Math.PI / 2), Math.PI, false);
  // self.ctx.stroke();

  // Text - 300MB
  self.ctx.font = 'bold 30px "Source Sans Pro"';
  self.ctx.fillStyle = '#FFF';
  self.ctx.textAlign="right";
  self.ctx.fillText("300 Mbps",370,110);

  // White circle path - 300MB
  self.ctx.lineWidth = 2;
  self.ctx.strokeStyle = '#FFF';
  self.ctx.beginPath();
  self.ctx.arc(self.params300mb.x, self.params300mb.y, self.params300mb.radius, -(Math.PI / 2), Math.PI, false);
  self.ctx.stroke();

  // Text - 1GB
  //self.ctx.font = 'bold 30px "Source Sans Pro"';
  //self.ctx.fillStyle = '#FFF';
  //self.ctx.textAlign="right";
  //self.ctx.fillText("1 Gbps",370,40);

  // White circle path - 1GB
  //self.ctx.lineWidth = 2;
  //self.ctx.strokeStyle = '#FFF';
  //self.ctx.beginPath();
  //self.ctx.arc(self.params1gb.x, self.params1gb.y, self.params1gb.radius, -(Math.PI / 2), Math.PI, false);
  //self.ctx.stroke();

  // Text - Your speed
  self.ctx.font = 'bold 34px "Source Sans Pro"';
  self.ctx.fillStyle = '#FFF';
  self.ctx.textAlign="right";
  if (self.options.yourSpeed == '100 Mbps') {
    self.ctx.fillText(self.options.yourSpeed,470,425);
  } else {
    self.ctx.fillText(self.options.yourSpeed,465,425);
  }

  // White circle path - Your Speed
  self.ctx.lineWidth = 2;
  self.ctx.strokeStyle = '#FFF';
  self.ctx.beginPath();
  self.ctx.arc(self.paramsYourSpeed.x, self.paramsYourSpeed.y, self.paramsYourSpeed.radius, -(Math.PI / 2), Math.PI, false);
  self.ctx.stroke();
}

CanvasSpeedtestMobile.prototype.getPointCoords = function(c1,c2,radius,angle)
{
  return [c1+Math.cos(angle)*radius,c2+Math.sin(angle)*radius];
}

CanvasSpeedtestMobile.prototype.Draw = function(params, increment)
{
  var self = this;

  // Animated line
  self.ctx.lineWidth = 14;
  var gradient = self.ctx.createLinearGradient(200,0,600,0);
  gradient.addColorStop(0,"#0071C3");
  gradient.addColorStop(1,"#0071C3");
  self.ctx.strokeStyle = gradient;
  self.ctx.lineCap = 'round';
  self.ctx.beginPath();
  self.ctx.arc(params.x, params.y, params.radius, -(Math.PI / 2), ((Math.PI * 2) * (params.curPercent/100)) - (Math.PI / 2), false);
  self.ctx.stroke();

  // White dot
  var dotCoords = self.getPointCoords(params.x, params.y, params.radius, ((Math.PI * 2) * (params.curPercent/100)) - (Math.PI / 2));
  self.ctx.beginPath();
  self.ctx.arc(dotCoords[0], dotCoords[1], 11, 0, 2* Math.PI, false);
  self.ctx.lineWidth = 0;
  self.ctx.strokeStyle = 'transparent';
  self.ctx.fillStyle = '#FFF';
  self.ctx.fill();
  self.ctx.stroke();

  if (params.curPercent < params.endPercent)
  {
    params.curPercent = params.curPercent + increment;
  }
  else
  {
    params.curPercent =  params.endPercent;
  }
}